<template>
  <ion-page class="bg-white">
    <ion-header class="ion-no-border text-white">
      <div class="px-16 pt-16">
        <ion-toolbar class="flex items-center p-0">
          <ion-buttons slot="start">
            <ion-button
              fill="solid"
              size="small"
              color="secondary"
              shape="round"
              class="headerButton"
              @click="onBack"
            >
              <ion-icon
                class="ml-[-2px] mr-2"
                aria-hidden="true"
                :icon="chevronBack"
              />
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </div>
    </ion-header>
    <ion-content fullscreen>
      <LockedLayout />
    </ion-content>
  </ion-page>
</template>

<script lang="ts" setup>
import {
  IonPage,
  useIonRouter,
  IonHeader,
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonContent,
} from '@ionic/vue';
import { chevronBack } from 'ionicons/icons';
import { useLightSystemBars } from '@/composeables/useSystemBarStyle';
import LockedLayout from '@/components/LockedLayout.vue';

const ionRouter = useIonRouter();

// White page with a transparent header.
useLightSystemBars();

const onBack = () => {
  ionRouter.back();
};
</script>

<style scoped>
ion-toolbar {
  --background: transparent;
  --border-width: 0px !important;
  --padding-top: 32px;
}
</style>
